import { Reducer, useReducer } from 'react';
import { RadioButtonProps, RadioButton } from './radiobutton';
import styles from './radioButtonGroup.scss';
import Icon from 'components/Shared/Icon/index';
import cn from 'classnames';

interface OwnState {
  checkedValue: string;
}

const initialState: OwnState = {
  checkedValue: ''
};

interface OwnAction {
  type: 'checked';
  value: string;
}

const ownReducer: Reducer<OwnState, OwnAction> = (state, action) => {
  switch (action.type) {
    case 'checked':
      return {
        ...state,
        checkedValue: action.value
      };
    default:
      return state;
  }
};

export interface RadioButtonGroupItemProps {
  label: string;
  value: string;
  id: string;
  checked: boolean;
}

export interface RadioButtonGroupProps extends RadioButtonProps {
  invalid?: boolean;
  items?: RadioButtonGroupItemProps[];
}

export const RadioButtonGroup = ({ items, onChange, invalid, name }: RadioButtonGroupProps) => {
  const [state, dispatch] = useReducer(ownReducer, initialState);

  const checked = (value: React.ReactText) => {
    onChange && onChange(value);
    dispatch({ type: 'checked', value: value.toString() });
  };

  const isChecked = (itemValue: string, itemDefaultChecked: boolean, stateValue: string) => {
    if (stateValue === '') {
      return itemDefaultChecked;
    }

    return itemValue === stateValue;
  };

  return (
    <div
      className={cn(styles.radioGroup, {
        [styles.invalid]: invalid
      })}
    >
      {items &&
        items.map(item => (
          <RadioButton
            key={item.id}
            value={item.value}
            label={item.label}
            name={name}
            checked={isChecked(item.value, item.checked, state.checkedValue)}
            onChange={checked}
          />
        ))}
      {invalid && <Icon icon="icon-warning" inline className={styles.icon} />}
    </div>
  );
};
